import ApisClient from '../utils/client/ApisClient';
import { InfoSIM } from '../models/ConfigureLine';
import { SimSelectionType } from '../pages/ConfigureLine/types';

export const getAllRestrictions = (productId: string) => {
    return ApisClient.get(`/restrictions?productId=${productId}`);
};

export const updateRestriction = (dataRestriction: any) => {
    return ApisClient.post('/restrictions/update', dataRestriction);
};

export const getSIMSInfos = async (): Promise<InfoSIM[]> => {
    const response = await ApisClient.get<InfoSIM[]>('/sims/infos');
    return response.data;
};
export const getSIMSInfo = async (productId: string): Promise<InfoSIM> => {
    const response = await ApisClient.get<InfoSIM>(`/sims/info?productId=${productId}`);
    return response.data;
};

export const getActivationLink = async (resourceId: string): Promise<string> => {
    const response = await ApisClient.get<string>(`/sims/esim/activation-link?resourceId=${resourceId}`);
    return response.data;
};

export const duplicateESIM = (productId: string) => {
    return ApisClient.post(`/sims/esim/duplicate`, { productId });
};

export const duplicateSIM = (productId: string) => {
    return ApisClient.post(`/sims/physical/duplicate`, { productId });
};

export const activateSIM = (phoneNumber: string, icc: string) => {
    return ApisClient.post(`/sims/physical/activate`, { phoneNumber, icc });
};

export const addMultiSim = (productId: string, type: SimSelectionType) => {
    return ApisClient.post(`/sims/multisim/hire`, { productId, type });
};
